import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";
import useGenerateInvoice from "./useGenerateInvoice";
import usePrepareGenerateInvoice from "./usePrepareGenerateInvoice";
import { GenerateInvoiceActionContext } from "./GenerateInvoiceActionContext";
import { Form } from "react-bootstrap";

function useGenerateInvoiceAction(modelConfig: any, index: any): any {
  const prepareGenerateInvoice = usePrepareGenerateInvoice();
  const prepareGenerateInvoiceFunction = (id: any) => prepareGenerateInvoice();

  const onSuccessGenerateInvoice = () => {
    setShowModal(false);
    index();
  };

  const generateInvoice = useGenerateInvoice(modelConfig);
  const generateInvoiceFunction = () => generateInvoice(onSuccessGenerateInvoice);

  const contextInstance = useContext(GenerateInvoiceActionContext);
  const { setShowModal, generatePdf, setGeneratePdf, sendToCustomer, setSendToCustomer, separatedInvoices, setSeparatedInvoices } = contextInstance;

  const modalConfig = {
    contextInstance: contextInstance,
    title: "create-invoice",
    onSubmit: () => generateInvoiceFunction(),
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <div>
        <p>{t(`are_you_sure_you_want_to_generate_the_invoice_for_these_${modelConfig.modelName}?`)}</p>
        <Form.Group className="mt-3">
          <Form.Check 
            type="checkbox"
            id="separated-invoices-checkbox-invoice"
            label={t("separated_invoices")}
            checked={separatedInvoices}
            onChange={(e) => setSeparatedInvoices(e.target.checked)}
          />
        </Form.Group>
        <Form.Group className="mt-3">
          <Form.Check 
            type="checkbox"
            id="generate-pdf-checkbox-invoice"
            label={t("generate_pdf")}
            checked={generatePdf}
            onChange={(e) => {
              setGeneratePdf(e.target.checked);
              // Si se desmarca generatePdf, desmarcar sendToCustomer también
              if (!e.target.checked) {
                setSendToCustomer(false);
              }
            }}
          />
        </Form.Group>
        <Form.Group className="mt-2">
          <Form.Check 
            type="checkbox"
            id="send-to-customer-checkbox-invoice"
            label={t("send_to_customer")}
            checked={sendToCustomer}
            disabled={!generatePdf}
            onChange={(e) => setSendToCustomer(e.target.checked)}
          />
          {!generatePdf && (
            <Form.Text className="text-muted">
              {t("requires_generate_pdf")}
            </Form.Text>
          )}
        </Form.Group>
      </div>
    </CrudModuleFactoryModal>
  );

  return {
    prepareGenerateInvoiceFunction,
    actionTemplate,
  };
}

export default useGenerateInvoiceAction;
